module.exports = __webpack_public_path__ + "static/media/hilary-duff-icon.d2460483.jpg";